import React, { Component } from 'react';
import Filters from '../../modules/Filters';
import { isTrue } from '../../helpers/isTrue';

class PageHeader extends Component {
    constructor(props) {
        super();
        this.showRefreshAll = isTrue(props.is_superuser) || isTrue(props.from_no_data);
        window.gsc_report = props.gsc_report;
    }

    handleRefreshAll() {
        const warningBar = document.getElementById('warning-container');
        const hidenElements = window.hidenElements ?? [];

        hidenElements.forEach((element) => {
            if (element.classList.contains('hide-component')) {
                element.classList.remove('hide-component');
            } else {
                element.style.display = 'block';
            }
        });
        if (warningBar) warningBar.style.display = 'none';
        const filters = window.filters;

        filters?.fns?.forEach((fn) => fn({ force: true, alreadyInQueue: true }));
    }

    render() {
        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap">
                <h2 className="page-title">{this.props.header}</h2>
                {!isTrue(this.props.hide_filters) && (
                    <div className="d-flex" style={{ zIndex: 1000 }}>
                        <Filters
                            gsc_report={this.props.gsc_report}
                            select_by_week={this.props.select_by_week}
                        />
                        {this.showRefreshAll && (
                            <div className="refresh-all-container">
                                <button
                                    className="refresh-all-btn"
                                    onClick={this.handleRefreshAll}
                                    title="Reload data"
                                >
                                    <i className="icon-Frame-converted" />
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default PageHeader;
